var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoIcn = function SvgLogoIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.333 27.314-4.87-6.556-1.254 1.541v5.015h-3.424V11h3.424v7.265L49.897 11h4.22l-6.387 7.655 6.82 8.659h-4.217Zm18.701-.007-3.088-5.795h-2.45v5.795h-3.338V11h7.35c3.275 0 5.3 2.225 5.3 5.265 0 2.86-1.765 4.422-3.463 4.84l3.558 6.209-3.87-.007Zm.338-11.074c0-1.344-1.015-2.176-2.33-2.176h-3.545v4.398h3.534c1.32 0 2.33-.828 2.33-2.222h.011Zm9.648 4.376V11h3.529v9.512c0 2.235 1.327 3.773 3.857 3.773 2.53 0 3.833-1.538 3.833-3.773V11h3.565v9.609c0 3.963-2.41 6.705-7.412 6.705-5 0-7.373-2.753-7.373-6.705Zm20.902 6.701v-2.809l7.587-10.443h-7.587V11h12.066v2.788L104.4 24.255h7.757v3.059l-12.235-.004Zm18.863.004V11h11.209v3.058h-7.843v3.424h7.669v3.055h-7.662v3.718h7.843v3.059h-11.216Z",
    fill: "#404042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.794.09H16.487L0 16.396h16.397L32.794.089Z",
    fill: "url(#logo-icn_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.331 38.652 16.308 16.486 0 0v16.397l30.331 22.255Z",
    fill: "#4791CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.146 13.936h.408l-.745-1.176a.785.785 0 0 0 .417-.29.89.89 0 0 0 .156-.502c0-.272-.086-.486-.257-.64-.169-.155-.418-.232-.746-.232h-.712v2.84h.341v-1.12h.442l.696 1.12Zm-1.138-1.412v-1.133h.392c.424 0 .636.19.636.569a.561.561 0 0 1-.156.409c-.101.104-.248.155-.442.155h-.43Z",
    fill: "#404042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138 12.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-.31 0a2.19 2.19 0 1 1-4.38.001 2.19 2.19 0 0 1 4.38-.001Z",
    fill: "#404042"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icn_svg__a",
    x1: 16.397,
    y1: 16.397,
    x2: 16.397,
    y2: 0.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#034C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#035787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0274A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00A3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADE5"
  })))));
};
export default SvgLogoIcn;